import { useEffect } from 'react';
import { Form } from 'react-bootstrap';
import { useFormContext } from 'react-hook-form';
import { useFieldContext } from './FieldContext';
import { resolvePath } from '../utils';

/**
 * @param {Object} props
 * @param {string} props.label
 * @param {string} props.id
 * @param {string} props.className
 * @param {boolean} props.boldLabel
 * @param {boolean} props.noMargin
 * @param {boolean} props.required
 * @param {string} props.invalid
 * @param {boolean} props.frozen
 */
export default function CheckboxInput({ label, id, className = "", boldLabel, noMargin, required, invalid, frozen, children, ...rest }) {
    const context = useFieldContext();
    id = context.idPrefix + id;
    rest.disabled ||= context.disabled;

    const { register, unregister, formState: { errors } } = useFormContext();
    const error = id && resolvePath(errors, id);

    useEffect(() => () => {
        unregister(id);
    }, []);

    return (
        <Form.Group className={`form-group flex flex-col text-start nth-[1]:mt-0 ${className}`}>
            <Form.Check>
                <Form.Check.Input isInvalid={error} {...register(id, { ...rest, required })} frozen={frozen ? "" : undefined} />
                {label && <Form.Check.Label style={boldLabel ? { fontWeight: "600", opacity: "1" } : {}}>{label}</Form.Check.Label>}
                {error && <Form.Control.Feedback type="invalid" className="d-block mt-0.5 text-sm">{invalid ?? "This checkbox is required."}</Form.Control.Feedback>}
            </Form.Check>
            {children}
        </Form.Group>
    );
}